import AbstractPolicy from '@/Services/Auth/Policies/AbstractPolicy';

export default class StorePolicy extends AbstractPolicy {
    static viewAny(user, model = null) {
        return this._userHasPermission(user, 'store.viewAny');
    }

    static view(user, model = null) {
        return this._userHasPermission(user, 'store.view');
    }

    static create(user, model = null) {
        return this._userHasPermission(user, 'store.create');
    }

    static update(user, model = null) {
        return this._userHasPermission(user, 'store.update');
    }

    static delete(user, model = null) {
        return this._userHasPermission(user, 'store.delete');
    }

    static restore(user, model = null) {
        return this._userHasPermission(user, 'store.restore');
    }

    static forceDelete(user, model = null) {
        return this._userHasPermission(user, 'store.forceDelete');
    }

    static profitAndLoss(user, model = null) {
        if (!model) {
            if (this._userHasPermission(user, 'store.profitAndLoss')) {
                return true;
            }

            if (!user.stores || user.stores.length === 0) {
                return false;
            }

            for (const store of user.stores) {
                if (this._checkPermissions(store.assignment.permissions, 'store.profitAndLoss') ||
                    this._checkRolesForPermission(store.assignment.roles, 'store.profitAndLoss')) {
                    return true;
                }
            }

            return false;
        }

        let store = user.stores.find(store => store.id === model.id);

        if (!store) {
            return false;
        }

        return this._checkPermissions(store.assignment.permissions, 'store.profitAndLoss') ||
            this._checkRolesForPermission(store.assignment.roles, 'store.profitAndLoss');
    }
}
